import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import { CobrancaContaItem } from "core/features/cobranca/typings";
import moment from "moment";
import { useMemo } from "react";

function useCobrancaCardColumns() {
  return useMemo(() => {
    return [
      {
        title: "Vencimento",
        dataIndex: "dataVencimento",
        render: (data: string) => {
          return <Flex fontSize={12}>{moment(data).format("DD/MM/YYYY")}</Flex>;
        },
      },
      {
        title: "Descrição",
        dataIndex: "descricao",
        render: (data: string) => {
          return <Flex fontSize={12}>{data}</Flex>;
        },
      },
      {
        title: "Valor",
        dataIndex: "total",
        render: (total: number) => {
          return (
            <Flex fontSize={12} alignItems="center" justifyContent="center">
              {total ? "R$" + formatCurrency(total) : "--"}
            </Flex>
          );
        },
      },
      {
        title: "Situação",
        render: (original: CobrancaContaItem) => {
          const isPaga = !!original.dataPagamento;
          const isAtrasada =
            !isPaga &&
            moment(original.dataVencimento)
              .startOf("day")
              .isBefore(moment().startOf("day"));
          return (
            <Flex w="80px" alignItems="center" justifyContent="flex-end">
              <Tag
                variant="outline"
                rounded="full"
                py={2}
                colorScheme={isPaga ? "green" : isAtrasada ? "red" : "orange"}
                size="sm"
              >
                {isPaga ? "Pago" : isAtrasada ? "Em atraso" : "Pendente"}
              </Tag>
            </Flex>
          );
        },
      },
    ];
  }, []);
}

export default useCobrancaCardColumns;
